import React from 'react';
import ContentLoader from 'react-content-loader';

const ProInfosLoader = props => (
  <ContentLoader
    speed={2}
    viewBox="0 0 400 170"
    primarycolor="#f3f3f3"
    secondarycolor="#ecebeb"
    aria-label={'Chargement en cours...'}
    uniqueKey="proInfosLoader"
    {...props}
  >
    <rect x="100" y="90" rx="3" ry="3" width="150" height="12" />
    <rect x="100" y="120" rx="3" ry="3" width="160" height="12" />
    <rect x="100" y="150" rx="3" ry="3" width="180" height="12" />
  </ContentLoader>
);

export default ProInfosLoader;
